import isEmpty from "lodash/isEmpty"
import React from "react"
import { useTranslation } from "react-i18next"
import { SelectPill } from "@/components/select-pill/select-pill.tsx"
import { useGetAnimalsQuery } from "@/features/farm/api/animals-api.ts"

interface CustomTriggerProps {
  currentValue: string[] | string
  onClick: () => void
}

const DrawerAnimalsFilterTrigger = React.forwardRef<
  HTMLButtonElement,
  CustomTriggerProps
>(({ currentValue, onClick }, ref) => {
  const { t } = useTranslation()
  const { data: allAnimals } = useGetAnimalsQuery()

  const isSelected = () => {
    return !isEmpty(currentValue)
  }

  function getAssociatedAnimalsInfo() {
    if (typeof currentValue === "string") {
      if (currentValue === "") {
        return t("allAnimals")
      }
      return (
        allAnimals?.find((animal) => animal.id === currentValue)?.name ||
        t("oneAnimalSelected")
      )
    }
    if (currentValue?.length === 0 || !currentValue) {
      return t("allAnimals")
    } else if (currentValue?.length === 1) {
      return t("oneAnimalSelected")
    } else {
      return `${currentValue?.length} ` + t("animalsSelected")
    }
  }

  return (
    <SelectPill isActive={isSelected()} ref={ref} onClick={onClick}>
      {getAssociatedAnimalsInfo()}
    </SelectPill>
  )
})

DrawerAnimalsFilterTrigger.displayName = "DrawerAnimalsFilterTrigger"

export default DrawerAnimalsFilterTrigger
